import { render } from "./Gebelik.vue?vue&type=template&id=65e7eedc&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml"
import script from "./Gebelik.vue?vue&type=script&lang=js"
export * from "./Gebelik.vue?vue&type=script&lang=js"

import "./Gebelik.vue?vue&type=style&index=0&id=65e7eedc&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__